import * as React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';
import LoginIcon from '@mui/icons-material/Login';
import FontSize from '../../layouts/FontSize';
import Color from '../../layouts/Color';

const navbar = { 
    fontWeight: 600, 
    fontSize: FontSize.Big, 
    color: Color.Sub
};

const logo = { 
    fontWeight: 600, 
    fontSize: FontSize.Big, 
    color: Color.Main 
};

const loginButton = {
    bgcolor: Color.Main,
    borderRadius: '30px',
    boder: '1px solid',
    fontWeight: '500',
    textAlign: 'center',
    padding: '10px 30px',
    transition: '0.3s',
    fontSize: FontSize.Medium,
    textTransform: 'none',
    '&:hover': {background: Color.Button}
  };

function Header() {
    return (
             <header className="header-section register login">
                <div className="overlay">
                    <div className="container">
                        <div className="row d-flex header-area">
                            <nav className="navbar d-flex justify-content-between navbar-expand-lg navbar-dark">
                                <Link className="navbar-brand" to="/" style={navbar}>
                                    <span className="logo-home" />APO<span style={logo}>LLO</span>
                                </Link>
                                <div className="d-flex align-items-center justify-content-end">
                                    <div className="right-area header-action d-flex align-items-center">
                                        <Button
                                            variant="contained"
                                            component={Link}
                                            to={'/signin'}
                                            endIcon={<LoginIcon />}
                                            sx={loginButton}
                                        >
                                            Sign In
                                        </Button>
                                    </div>
                                </div>
                            </nav>
                        </div>
                    </div>
                </div>
            </header>
    );
}

export default Header;